import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTheme } from 'styled-components'

import { Flex, FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H4 } from '@/@bothrs-ui/web/components/typography/Heading'
import { StContainer } from './SignableDocumentReviewCard.styled'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'

type SignableDocumentReviewCardProps = {
  title: string
  icon?: IconProp
  description: string
  reviewed?: boolean
  onClick?: () => void
}

const SignableDocumentReviewCard = ({
  title,
  icon,
  description,
  reviewed,
  onClick,
}: SignableDocumentReviewCardProps) => {
  const theme = useTheme()

  const handleClick = () => {
    if (!reviewed && onClick) {
      onClick()
    }
  }

  return (
    <StContainer onClick={handleClick} reviewed={reviewed}>
      <Flex alignItems='center' gap={theme.UI.Spacing.Space2}>
        <FlexColumn gap={theme.UI.Spacing.Space2} justifyContent='center' style={{ width: '100%' }}>
          <Flex justifyContent='flex-start' alignItems='center' gap={theme.UI.Spacing.Space2}>
            {icon ? <FontAwesomeIcon icon={icon} /> : null}
            <H4 noMargin>{title}</H4>
          </Flex>
          {reviewed ? null : (
            <Flex justifyContent='space-between' alignItems='center'>
              <Span type='BodySmallRegular' color={theme.Colors.Neutrals.Darker}>
                {description}
              </Span>
              <FontAwesomeIcon icon={['far', 'chevron-right']} color={theme.Colors.Neutrals.Darkest} />
            </Flex>
          )}
        </FlexColumn>
      </Flex>
    </StContainer>
  )
}

export { SignableDocumentReviewCard }
